<div class="header" id="header">
    <div class="topHead">
        <h1>
            <a (click)="onClickHomePage()" title="HOME" class="logo">
                <img src="./assets/img/Logo.svg" alt="">
            </a>
        </h1>
        <ng-container [ngTemplateOutlet]="mainMenuTemplate"
            [ngTemplateOutletContext]="{ isCollapse: false }"></ng-container>
    </div>
    <div class="btmHead">
        <ng-container [ngTemplateOutlet]="rightMenuTemplate"
            [ngTemplateOutletContext]="{ isCollapse: false }"></ng-container>
        <div class="shopCont">
            <div class="searchWrap">
                <input type="text" (click)="closeCollapse('mobileCollapse')" [(ngModel)]="key" (keydown.enter)="handleOnSearch()" placeholder="검색어를 입력하세요."
                    onfocus="this.placeholder=''">
                <a role="button" (click)="handleOnSearch()"><svg xmlns="http://www.w3.org/2000/svg" width="24"
                        height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    </svg></a>
            </div>
            <a class="cartBtn" (click)="closeCollapse('mobileCollapse')" routerLink="/shopping-mall/cart">
                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="10" cy="20.5" r="1" />
                    <circle cx="18" cy="20.5" r="1" />
                    <path d="M2.5 2.5h3l2.7 12.4a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6l1.6-8.4H7.1" />
                </svg>
                <span>{{ cartLength }}</span>
            </a>
            <a role="button" class="mobiTggBtn">
                <input type="checkbox" id="icon">
                <label for="icon" data-bs-toggle="collapse" href="#mobileCollapse" role="button" aria-expanded="false"
                    aria-controls="mobileCollapse" (click)="openCollapse()">
                    <span></span>
                    <span></span>
                    <span></span>
                </label>
            </a>
        </div>
    </div>
    <div class="mobiSearch">
        <input type="text" [(ngModel)]="key" (keydown.enter)="handleOnSearch()" placeholder="검색어를 입력하세요."
            onfocus="this.placeholder=''" />
        <a role="button" (click)="handleOnSearch()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
        </a>
    </div>


</div>

<div class="collapse" id="mobileCollapse">
    <div class="card card-body">
        <div class="mobiTggMenu">
            <div class="mobiTggWrap d-flex flex-column">
                <div class="gnbClone flex-grow-1">
                    <ng-container [ngTemplateOutlet]="rightMenuTemplate"
                        [ngTemplateOutletContext]="{ isCollapse: true }"></ng-container>
                </div>
                <div class="accountClone">
                    <ng-container [ngTemplateOutlet]="mainMenuTemplate"
                        [ngTemplateOutletContext]="{ isCollapse: true }"></ng-container>
                </div>
            </div>
        </div>
    </div>
</div>


<app-autologout style="display: none;"></app-autologout>
<ngx-loading [show]="loading"></ngx-loading>

<ng-template #mainMenuTemplate let-isCollapse="isCollapse">
    <ul class="topAccount" id="topAccount">
        <li (click)="closeCollapse(isCollapse ? 'mobileCollapse' : '')">
            <a (click)="handleClickHomePage('2')">쇼핑하기</a>
        </li>
        <li (click)="closeCollapse(isCollapse ? 'mobileCollapse' : '')">
            <a (click)="handleClickMyoffice('2')">마이오피스</a>
        </li>
        <li>|</li>
        <ng-container *ngFor="let item of rightMenu;">
            <ng-container *ngIf="item.prgId == 'mr.Signup'">
                <li (click)="closeCollapse(isCollapse ? 'mobileCollapse' : '')"><a href="javascript:;"
                        (click)="handleOnClickRightMenu(item);">{{ item.prgName }}</a></li>
            </ng-container>
        </ng-container>
        <ng-container *ngFor="let item of rightMenu;">
            <ng-container
                *ngIf="item.prgId != 'mr.Signup' && (item.loginYn == 'A' || (isLogin && item.loginYn == 'Y') || (!isLogin && item.loginYn == 'N'))">
                <li (click)="closeCollapse(isCollapse ? 'mobileCollapse' : '')"><a href="javascript:;"
                        (click)="handleOnClickRightMenu(item);">{{ item.prgName }}</a></li>
            </ng-container>
        </ng-container>
    </ul>
</ng-template>

<ng-template #rightMenuTemplate let-isCollapse="isCollapse" let-direction="direction">
    <ng-container *ngIf="isHomepage">
        <ul class="gnb row row-cols-4 row-cols-sm-auto" id="gnb">
            <ng-container *ngFor="let itemsub of leftmenusub">
                <ng-container *ngIf="itemsub.menuYn == 'Y'">
                    <li class="col" [ngClass]="itemsub.prgId === tempActiveId ? 'active' : ''"
                        (click)="closeCollapse(isCollapse ? 'mobileCollapse' : '')">
                        <a href="#" [routerLink]="itemsub.linkInfo" class="level-1 d-flex justify-content-center">
                            <span class="d-md-block d-none">
                                {{ itemsub.prgName }}
                            </span>
                        </a>
                    </li>
                </ng-container>
            </ng-container>
        </ul>
    </ng-container>

    <ng-container *ngIf="isClickedMF">
        <ul class="gnb" id="gnb">
            <ng-container *ngFor="let item of mainItems">
                <ng-container *ngIf="userKindCd == 'U10'">
                    <ng-container *ngIf="item.data.menuYn === 'Y'">
                        <li class="menu-item col-auto" [attr.data-program-id]="item.data.prgId"
                            [ngClass]="activeId === item.data.prgId ? 'active' : ''">
                            <a (click)="onClickCategory(item.data, isCollapse ? 'mobileCollapse' : '')" class="a1">
                                <span class="d-md-block d-none">{{ item.data.prgName }}</span>
                            </a>
                        </li>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="userKindCd == 'U00'">
                    <ng-container *ngIf="item.data.menuYn === 'Y' 
                                      && item.data.prgId != 'ml.Office.Member-management'
                                      && item.data.prgId != 'ml.Office.Benefit-management'
                                      && item.data.prgId != 'ml.Office.omnitrition'">
                        <li class="menu-item col-auto" [attr.data-program-id]="item.data.prgId"
                            [ngClass]="activeId === item.data.prgId ? 'active' : ''">
                            <a (click)="onClickCategory(item.data, isCollapse ? 'mobileCollapse' : '')" class="a1">
                                <span class="d-md-block d-none">{{ item.data.prgName }}</span>
                            </a>
                        </li>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ul>
    </ng-container>

    <ul class="gnb row row-cols-4 row-cols-sm-auto ul-home" [ngClass]="isLogin?'gnb-home':''" id="gnb">
        <ng-container *ngFor="let itemsub of leftmenusub">
            <ng-container *ngIf="itemsub.menuYn == 'Y'">
                <li class="col" [ngClass]="itemsub.prgId === tempActiveId ? 'active' : ''"
                    (click)="closeCollapse(isCollapse ? 'mobileCollapse' : '')">
                    <a href="#" [routerLink]="itemsub.linkInfo" class="level-1 d-flex justify-content-center">
                        <div class="mainIconMenu d-md-none d-block">
                            <a class="d-flex justify-content-center flex-column align-items-center">
                                <div class="icon-home"><img [src]="urlWownet + '/' + itemsub.filePath + itemsub.fileName"></div>
                                <p>{{ itemsub.prgName }}</p>
                            </a>
                        </div>
                    </a>
                </li>
            </ng-container>
        </ng-container>
    </ul>

    <ul class="gnb row row-cols-4 row-cols-sm-auto" id="gnb">
        <ng-container *ngFor="let item of mainMenu">
            <ng-container *ngIf="userKindCd == 'U10'">
                <ng-container *ngIf="item.pid == 'ml.Office' && item.menuLv == '1' && item.menuYn == 'Y' && isLogin">
                    <li class="col" [ngClass]="item.prgId === tempActiveId ? 'active' : ''"
                        (click)="closeCollapse(isCollapse ? 'mobileCollapse' : '')">
                        <a href="#" [routerLink]="item.linkInfo" class="level-1 d-flex justify-content-center">
                            <div class="mainIconMenu d-md-none d-block">
                                <a class="d-flex justify-content-center flex-column align-items-center">
                                    <div class="icon-myoffice"><img src="./assets/img/my-office/{{ item.icon }}.png"></div>
                                    <p>{{ item.prgName }}</p>
                                </a>
                            </div>
                        </a>
                    </li>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="userKindCd == 'U00'">
                <ng-container *ngIf="item.pid == 'ml.Office' && item.menuLv == '1' && item.menuYn == 'Y' && isLogin
                                  && item.prgId != 'ml.Office.Member-management'
                                  && item.prgId != 'ml.Office.Benefit-management'
                                  && item.prgId != 'ml.Office.omnitrition'">
                    <li class="col" [ngClass]="item.prgId === tempActiveId ? 'active' : ''"
                        (click)="closeCollapse(isCollapse ? 'mobileCollapse' : '')">
                        <a href="#" [routerLink]="item.linkInfo" class="level-1 d-flex justify-content-center">
                            <div class="mainIconMenu d-md-none d-block">
                                <a class="d-flex justify-content-center flex-column align-items-center">
                                    <div class="icon-myoffice"><img src="./assets/img/my-office/{{ item.icon }}.png"></div>
                                    <p>{{ item.prgName }}</p>
                                </a>
                            </div>
                        </a>
                    </li>
                </ng-container>
            </ng-container>
        </ng-container>
    </ul>
</ng-template>
